import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Uang Muka Pembelian',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Uang Muka Pembelian',
        href: '/adm/fin/pembelian/invoice',
        active: true,
      },
    ],
    form_title: 'Form Uang Muka Pembelian',
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_um_beli',
    sortDesc: true,
    filter_custom: false,
    fields: [
      {
        key: 'code_um',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Supplier',
      },
      {
        key: 'date_um',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'currency_name',
        label: 'Currency',
      },
      {
        key: 'nominal',
        label: 'Nominal',
      },
      {
        key: 'terpakai',
        label: 'Terpakai',
      },
      {
        key: 'sisa',
        label: 'Sisa',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'code_um',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Supplier',
      },
      {
        key: 'date_um',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'currency_name',
        label: 'Currency',
      },
      {
        key: 'total_sisa',
        label: 'Nominal',
      },
    ],
    form: {
      id_supplier: '',
      supplier_code: '',
      supplier_name: '',
      id_currency: '',
      acc_um: '',
      acc_um_code: '',
      acc_um_name: '',
      nominal: 0,
      date_um: '',
      memo: '',
    },
    journal: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeUMBeli(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListUM({ commit, state }, payload = null) {
    commit('changeUMBeli', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (data.filter_custom) {
      params = {
        ...params,
        ...data.filter_custom,
      };
    }

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/uang-muka-pembelian`, params);
      commit('changeUMBeli', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_um_beli.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`fin/uang-muka-pembelian`, params);
      commit('changeUMBeli', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getJournalUMBeli({ commit }, payload = null) {
    commit('changeUMBeli', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `fin/uang-muka-pembelian/${payload.id}/journal`
    );
    commit('changeUMBeli', {
      loading: false,
    });

    if (!result.error) {
      commit('changeUMBeli', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getDetailUangMuka({ commit, state }, payload = null) {
    commit('changeUMBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/uang-muka-pembelian/${payload.id}`);
    commit('changeUMBeli', {
      loading: false,
    });

    if (!result.error) {
      commit('changeUMBeli', {
        detail: result.data.object,
        form: {
          ...data.form,
          ...result.data.object,
          date_um: result.data.object.date_um
            ? moment(result.data.object.date_um).format('DD/MM/YYYY')
            : moment().format('DD/MM/YYYY'),
        },
      });
    }

    return !result.error ? true : false;
  },

  async createUangMuka({ commit, state, dispatch }) {
    commit('changeUMBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/uang-muka-pembelian', data.form);

    commit('changeUMBeli', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateUangMuka({ commit, state, dispatch }, payload = null) {
    commit('changeUMBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `fin/uang-muka-pembelian/${payload.id}`,
      data.form
    );

    commit('changeUMBeli', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteUM({ commit, dispatch }, payload = null) {
    commit('changeUMBeli', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `fin/uang-muka-pembelian/${payload.id}`
    );
    commit('changeUMBeli', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
